import axios from "axios";
import { getNodeToken } from './auth_node'
import swal from "sweetalert";
import { cleanCookies } from "../utils/Utils";
const api = axios.create({
     baseURL: "https://voittoapi.herokuapp.com/v2/", 
  // baseURL: "https://apiv2.voitto.com.br/v2/", 
  // baseURL: "http://localhost:3333/v2/", 
  headers: { 
    'access_token': `voitto-token ${getNodeToken()}`
  },
});
api.interceptors.response.use(response => {
  return response;
}, error => {
    if(error.response  && window.location.href.indexOf('login') < 0){
      if (401 === error.response.status) {
        swal( "Sua sessão expirou","Estamos te redirecionando para a tela de login!", "warning").then(()=>{
          localStorage.setItem('redirect', window.location.pathname);
          localStorage.removeItem("Token");
          localStorage.removeItem("oauth_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("USER");
          localStorage.removeItem("USER_NODE");
          cleanCookies().then(() => {
            window.location.href = '/login'
          });
        })
      }
    }
  return Promise.reject(error); 
});
export default api; 